<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter4">
<h1><a id="page_15"></a><a href="#/007toc#chapter4">ELEMENTS OF A HANDMADE WEDDING</a></h1>
<p class="noindent">Many elements go into designing a wedding, from essentials to special extras. Although just about every aspect of a wedding has DIY potential, your schedule, budget, and energy will limit the number of projects you can take on. It’s therefore ideal to think about which items are the most high-impact and feasible to make in the time you have—and important to you in terms of adding a personal, creative touch to your wedding.</p>
<p class="noindent">Here is a quick framework that can help you think about which ideas to prioritize.</p>
<div class="table" id="table1">
<table>
<tbody><tr>
<td class="bdrtop bdrbottom"><strong>Definitely DIY</strong></td>
<td class="bdrtop bdrbottom bdrleft"><strong>Buy, rent, or plan ahead</strong></td>
</tr>
<tr>
<td class="bdrbottom">One-offs, e.g., a ring pillow</td>
<td class="bdrbottom bdrleft">Multiples, e.g., invitations</td>
</tr>
<tr>
<td class="bdrbottom">Simple projects</td>
<td class="bdrbottom bdrleft">Complicated projects, or those that <br/>
  require learning a new skill</td>
</tr>
<tr>
<td class="bdrbottom">Projects that play to an existing creative <br/>
  talent, skill, or hobby, e.g., knitting, sewing, <br/>
  or collecting</td>
<td class="bdrbottom bdrleft">Anything that could affect guest comfort<br/>
or safety, e.g., furniture or food</td>
</tr>
<tr>
<td class="bdrbottom">Items that have sentimental or <br/>
  keepsake value</td>
<td class="bdrbottom bdrleft">Anything that is cheaper to buy or rent or <br/>
  that you just don’t feel like making</td>
</tr>
</tbody></table>
</div>
<p class="noindent">On the following page we’ve provided a checklist of elements that make up a typical wedding. Although all of them have DIY potential, we’ve found that the items in bold type generally are the easiest to tackle. Remember, DIY projects are usually more time-consuming, and can sometimes be more expensive, than hiring a pro or buying a premade item. So choose wisely, and don’t put too much pressure on yourself. The goal is to be healthy, happy, and relaxed on your wedding day, so enlist lots of help and keep your expectations grounded.</p>
<h3 class="left"><a id="page_16"></a>CHECKLIST</h3>
<h4>Invitations</h4>
<ul class="circle">
<li>Save-the-dates</li>
<li>Wedding invitations and enclosures</li>
<li>Rehearsal dinner invitations</li>
<li>Thank-you notes</li>
</ul>
<h4>Favors and gifts</h4>
<ul class="circle">
<li>Guest welcome bag or letter</li>
<li>Favors</li>
<li>Bridesmaids and groomsmen gifts</li>
</ul>
<h4>Attire</h4>
<ul class="circle">
<li>Corsages (for bridesmaids, mothers of the bride and groom)</li>
<li>Boutonnieres (for groomsmen, fathers of the bride and groom)</li>
<li>Flower girl garland, headband, or tiara/crown</li>
<li>Bridal headpiece or veil</li>
<li>Neckties, bow ties, pocket squares, and cuff links (for groomsmen)</li>
<li>Bride and bridesmaids jewelry</li>
<li>Bridal party attire</li>
</ul>
<h4>Ceremony</h4>
<ul class="circle">
<li>Welcome sign</li>
<li>Programs</li>
<li>Altar or chuppah</li>
<li>Aisle markers</li>
<li>Reserved seating signs</li>
<li>Ring pillow</li>
<li>Flower girl basket or apron</li>
<li>Confetti pouches</li>
</ul>
<h4>Reception—cocktail hour</h4>
<ul class="circle">
<li>Seating cards/displays</li>
<li>Drink flags or stir sticks</li>
<li>Food packaging (e.g., doughnut bags, paper cones)</li>
<li>Cocktail napkins</li>
<li>Bar and buffet signs</li>
<li>Photo booth or photo-booth backdrop</li>
<li>Guest book</li>
</ul>
<h4>Reception—dinner and dancing</h4>
<ul class="circle">
<li>Pom-poms or garlands</li>
<li>Table runners</li>
<li>Centerpieces</li>
<li>Votives or decorative vessels for flowers</li>
<li>Table numbers</li>
<li>Place settings and napkins</li>
<li>Menus</li>
<li>Place cards</li>
<li>Bride and groom’s seating signs</li>
<li>Cake topper</li>
<li>Cake or dessert bar stands</li>
<li>Just Married sign</li>
</ul>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 012chapter4.vue?2ee3af85